// extracted by mini-css-extract-plugin
export var arrows = "_4s-6";
export var decrementer = "_4s-a";
export var disabled = "_4s-4";
export var error = "_4s-1";
export var hiddenText = "_4s-b";
export var incrementer = "_4s-9";
export var input = "_4s-8";
export var inputWrapper = "_4s-0";
export var leadingIcon = "_4s-c";
export var readonly = "_4s-3";
export var regular = "_4s-7";
export var small = "_4s-5";
export var warning = "_4s-2";